/**
 * Weekly goal (target tracked hours per week) — client-side storage.
 *
 * Like the billing rates, the target is a private, offline-first reporting
 * preference stored in localStorage rather than the synced schema (it doesn't
 * warrant a migration across the sync pipeline). The pure progress math lives in
 * `@time-tracker/shared` (`computeWeeklyGoalProgress`); this module only reads and
 * writes the stored target, SSR-safely.
 */

import {
  clampWeeklyGoalHours,
  parseWeeklyGoalHours,
  WEEKLY_GOAL_STORAGE_KEY,
} from "@time-tracker/shared";

/** Reads the stored weekly goal in hours (0 = unset / no goal). */
export function getWeeklyGoalHours(): number {
  if (typeof localStorage === "undefined") {
    return 0;
  }
  return parseWeeklyGoalHours(localStorage.getItem(WEEKLY_GOAL_STORAGE_KEY));
}

/** Persists the weekly goal in hours (clamped to a valid range). */
export function setWeeklyGoalHours(hours: number): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  localStorage.setItem(WEEKLY_GOAL_STORAGE_KEY, String(clampWeeklyGoalHours(hours)));
}
